import { ExpandLess, ExpandMore } from "@mui/icons-material";
import {
  Collapse,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
} from "@mui/material";
import PropTypes from "prop-types";
import React, { useState } from "react";
import { Link } from "react-router-dom";

export default function TripleLevel({ child }) {
  const [open2, setOpen2] = useState(false);
  const handleClick2 = () => {
    setOpen2((prev) => !prev);
  };
  return (
    <>
      <div style={{ background: open2 ? "#32523a" : "none" }}>
        <ListItem button onClick={handleClick2}>
          <ListItemIcon style={{ color: "#b0b0b0" }}></ListItemIcon>
          <ListItemText primary={child.title} />
          {open2 ? <ExpandLess /> : <ExpandMore />}
        </ListItem>

        <Collapse in={open2}>
          <List component="div" disablePadding>
            {child.items.map((child2, key2) => (
              <Link
                to={child2.path}
                key={key2}
                style={{ textDecoration: "none", color: "white" }}
              >
                <ListItem
                  button
                  style={{
                    background:
                      window.location.pathname === child2.path
                        ? "#36B057"
                        : "none",
                  }}
                >
                  <ListItemIcon style={{ color: "white" }}>
                    {child2.icon}
                  </ListItemIcon>
                  <div style={{ width: "20px" }} />
                  <ListItemText primary={child2.title} />
                </ListItem>
              </Link>
            ))}
          </List>
        </Collapse>
      </div>
    </>
  );
}

TripleLevel.propTypes = {
  child: PropTypes.object,
};
